import NewScaffoldingFormDialog from './NewScaffoldingFormDialog';

export default NewScaffoldingFormDialog;
